import { Storage } from './Storage';

interface Record {
  country_code: string,
  latitude: number,
  longitude: number
}

interface RecordObj {
  countryCode: string,
  coords: {
    latitude: number,
    longitude: number
  }
}
/**
 * Geolocation helpers class
 * @class
 */
class Geolocation {
  private countryCodeStorageName: string = 'geolocation--country-code';
  private recordStorageName: string = 'geolocation--record';
  private storageTimeout: number = 1000 * 60 * 60;

  constructor() {

  }

  /**
   * checks for country code using ajax
   * @return {Promise<string>}
   */
  private _fetchCountryCode() {
    return new Promise<string>(function(resolve, reject) {
      var xhr = new XMLHttpRequest();
      xhr.open('GET', encodeURI('/stage-ajax/geoip/country-code'));
      xhr.onload = function() {
        if (xhr.status === 200) {
          resolve(JSON.parse(xhr.responseText));
          //alert('User\'s name is ' + xhr.responseText);
        }
        else {
          reject(xhr.status);
          //alert('Request failed.  Returned status of ' + xhr.status);
        }
      };

      xhr.send();
    });
  }

  private _fetchRecord() {
    return new Promise<Record>(function(resolve, reject) {
      var xhr = new XMLHttpRequest();
      xhr.open('GET', encodeURI('/stage-ajax/geoip/record'));
      xhr.onload = function() {
        if (xhr.status === 200) {
          resolve(JSON.parse(xhr.responseText));
        }
        else {
          reject(xhr.status);
        }
      };

      xhr.send();
    });
  }

  /**
   * get country code of client
   * @return {Promise<string>} country code
   */
  public getCountryCode() {
    var self = this,
      storedCountryCode;

    return new Promise<string>(function(resolve, reject) {
      storedCountryCode = Storage.getLocalStorageItem(self.countryCodeStorageName);

      if (!storedCountryCode) {
        self._fetchCountryCode().then(function(res) {

          // Save country code to localStorage for further queries
          Storage.setLocalStorageItem(self.countryCodeStorageName, res, self.storageTimeout);
          resolve(res);
        }, function(res) {
          console.log('Geolocation#getCountryCode error: ' + res);
          reject();
        });
      } else {
        resolve(storedCountryCode);
      }
    });
  }

  public getGeoIPRecord() {
    var self = this,
      storedRecord,
      recordObj;

    return new Promise<RecordObj> (function(resolve, reject) {
      storedRecord = Storage.getLocalStorageItem(self.recordStorageName);

      if (!storedRecord) {
        self._fetchRecord().then(function(res) {

          recordObj = {
            'countryCode': res.country_code,
            'coords': {
              'latitude': res.latitude,
              'longitude': res.longitude
            }
          };
          // Save country code to localStorage for further queries
          Storage.setLocalStorageItem(self.countryCodeStorageName, recordObj.countyCode, self.storageTimeout);

          // And full record data
          Storage.setLocalStorageItem(self.recordStorageName, recordObj, (1000 * 60 * 60));
          resolve(recordObj);
        }, function(res) {
          console.log('Geolocation#getCountryCode error: ' + res);
          reject();
        });
      } else {
        resolve(storedRecord);
      }
    });
  }

  /**
   * get geolocation object
   * @return {Promise<object>} geolocation
   */
  public getGeolocation() {
    return new Promise<Object>(function(resolve, reject) {
      if ('geolocation' in navigator) {
        navigator.geolocation.getCurrentPosition(function(position) {

          resolve({
            'latitude': position.coords.latitude,
            'longitude': position.coords.longitude
          });

        }, function(error) {

          // If coordinate fetch failed for some reason
          resolve(null);
        }, { enableHighAccuracy: false, timeout: 60000, maximumAge: 0 });
      } else {

        // If this is older browser or api is disabled
        resolve(null);
      }
    });
  }

  /**
   * find nearest from array of arrays of numbers
   * @param {Array<number>}        targetCoords [description]
   * @param {Array<Array<number>>} items        [description]
   * @return {int} index of values
   */
  public findNearest(targetCoords: Array<number>, items: Array<Array<number>>) {
    var i, l, distance, smallestDistance, smallestDistanceIndex;

    for (i = 0, l = items.length; i < l; i++) {
      distance = this.getDistanceBetween(targetCoords, items[i]);

      if(!smallestDistance || distance < smallestDistance) {
        smallestDistance = distance;
        smallestDistanceIndex = i;
      }
    }

    return smallestDistanceIndex;
  }

  public getDistanceBetween(startCoords: Array<number>, endCoords: Array<number>) {
    var R = 6371, // km
        dLat = this.toRad(endCoords[0] - startCoords[0]),
        dLon = this.toRad(endCoords[1] - startCoords[1]),
        lat1 = this.toRad(startCoords[0]),
        lat2 = this.toRad(endCoords[0]),
        a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.sin(dLon / 2) * Math.sin(dLon / 2) * Math.cos(lat1) * Math.cos(lat2),
        c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a)),
        d = R * c;

    return d;
  }

  /**
   * convert number to rad
   * @param {number} val number
   * @return {number} rad
   */
  public toRad(val) {
    return val * Math.PI / 180;
  }
}

var geolocation = new Geolocation();

export { geolocation as Geolocation }
